import type { AuthState, AuthUser, PendingEmail } from "@/types/auth.types";

export type AuthAction =
  | { type: "SET_LOADING"; payload: boolean }
  | { type: "SET_USER"; payload: AuthUser | null }
  | { type: "SET_PENDING_EMAIL"; payload: PendingEmail | null }
  | { type: "SET_ERROR"; payload: string | null }
  | { type: "UPDATE_TOKEN_CHECK" }
  | { type: "SIGN_OUT" };

export const initialState: AuthState = {
  user: null,
  isLoading: true,
  pendingEmail: null,
  error: null,
  lastTokenCheck: undefined,
};

export const authReducer = (state: AuthState, action: AuthAction): AuthState => {
  switch (action.type) {
    case "SET_LOADING":
      return {
        ...state,
        isLoading: action.payload,
      };
    case "SET_USER":
      return {
        ...state,
        user: action.payload,
      };
    case "SET_PENDING_EMAIL":
      return {
        ...state,
        pendingEmail: action.payload,
      };
    case "SET_ERROR":
      return {
        ...state,
        error: action.payload,
      };
    case "UPDATE_TOKEN_CHECK":
      return {
        ...state,
        lastTokenCheck: Date.now(),
      };
    case "SIGN_OUT":
      return {
        ...initialState,
        isLoading: false,
      };
    default:
      return state;
  }
};
